import React, { Component } from 'react';

class InputDetails extends Component {

    constructor(props) {
        super(props);
        this.state = {
            inputValue: ""
        }
    }

    updateInputValue(evt) {
        this.setState({
            inputValue: evt.target.value
        });
    }

    render() {
        return (
            <div style={{display:'flex', flexDirection:'column', alignItems:'center'}}>
                <h4>{this.props.prompt}</h4>
                <input style={{fontSize:'2em', width:300, height:40, border:'none', borderRadius:10, marginBottom:10}} type={'text'} onChange={this.updateInputValue.bind(this)}/>
                <button className={'genericBtn'} onClick={()=>this.props.submit(this.state.inputValue)}>{this.props.submitText}</button>
            </div>
        )
    }
}
export default InputDetails;